import { Button, Space, Table } from 'antd'
import React from 'react'
import CustomBreadCrumb from '../../components/lib/CustomBreacCrumb';

const BlockList = () => {
  const dataSource = [
    {
      key: '1',
      name: 'Mike',
      age: 32,
      address: '10 Downing Street',
    },
    {
      key: '2',
      name: 'John',
      age: 42,
      address: '10 Downing Street',
    },
  ];

  const columns = [
    {
      title: '№',
      dataIndex: 'index',
      key: 'index',
    },
    {
      title: 'Зураг',
      dataIndex: 'thumbnail',
      key: 'thumbnail',
    },
    {
      title: 'Нэр',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Грөүп нэр',
      dataIndex: 'groupName',
      key: 'groupName',
    },
    {
      title: 'Гишүүдийн тоо',
      dataIndex: 'memberCount',
      key: 'memberCount',
    },
    {
      title: 'Owner id',
      dataIndex: 'ownerId',
      key: 'ownerId',
    },
    {
      title: 'Үүссэн огноо',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: 'Үйлдэл',
      key: 'action',
      render: (item: any) => {

        return (
          <>
            <Space>
              <Button style={{ color: 'blue' }} type="primary" className='!text-white'>
                un block
              </Button>

            </Space>
          </>
        )
      },
    },


  ];
  return (
    <div>
      <CustomBreadCrumb item={[{ name: 'Хянах самбар', link: '/dashboard' }, { name: 'Хориглосон гишүүдийн жагсаалт', link: '/chat/blockList' }]} />
      <Table dataSource={dataSource} columns={columns} />;
    </div>
  )
}

export default BlockList